import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../../app/theme';
import ImageDisplay from '../ImageDisplay';
import { HashtagUrlText } from '../HashtagText';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      minHeight: 52,
      marginBottom: 12,
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      maxWidth: 250,
      minHeight: 52,
      backgroundColor: color.$8,
      borderRadius: 12,
      padding: '8px 12px 5px',
    },
    content: {
      fontSize: 13,
      lineHeight: '19px',
      color: color.$13,
      overflowWrap: 'anywhere',
      whiteSpace: 'pre-wrap',
      '& .textMessageLink': {
        color: color.$13,
        textDecoration: 'underline',
        '&:hover': {
          opacity: 0.6,
        },
      },
    },
  }),
  {
    name: 'TextPreview',
  },
);

function TextPreview({ orgIconURL, message }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ImageDisplay
        style={{ objectFit: 'contain', borderRadius: '50%', marginRight: 12 }}
        src={orgIconURL}
        width={44}
        height={44}
      />
      <div className={classes.container}>
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: HashtagUrlText(message.data.content),
          }}
        />
      </div>
    </div>
  );
}

export default TextPreview;
